import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/device/tree/";

export class CreateNewFolderCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    params: CreateNewFolderReqData = null;

    constructor(parentId: number, newFolderName: string, createBranch: boolean, branchGln: string, branchLocation: string) {
        super();
        this.params = new CreateNewFolderReqData(parentId, newFolderName, createBranch, branchGln, branchLocation);
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.params);
        return new ApiGenericResponse(res);
    }
}

export class CreateNewFolderReqData {
    parentId: number;
    newFolderName: string;
    createBranch: boolean;
    branchGln: string;
    branchLocation: string;

    constructor(parentId: number, newFolderName: string, createBranch: boolean, branchGln: string, branchLocation: string) {
        this.parentId = parentId;
        this.newFolderName = newFolderName;
        this.createBranch = createBranch;
        this.branchGln = branchGln;
        this.branchLocation = branchLocation;
    }
}
